import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Navbar = ({ handleLogout }) => {
  const navigate = useNavigate();

  const handleSignOut = () => {
    // Clear the stored username and password
    localStorage.removeItem('username');
    // localStorage.removeItem('password');

    // Call the handleLogout function passed from the parent component
    handleLogout();

    // Navigate to the homepage
    navigate('/');
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light">
      <Link to="/" className="navbar-brand">SustainaBite</Link>
      <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className="collapse navbar-collapse" id="navbarNavDropdown">
       
      </div>
      <ul className="navbar-nav ml-auto">
      <li className="nav-item dropdown">
            <Link className="nav-link" to="/foodlist" id="navbarDropdownMenuLink" role="button">
              All Food
            </Link>
          </li>
        <li className="nav-item">
          <Link to="/reminder" className="nav-link">Reminder</Link>
        </li>
        <li className="nav-item">
          <Link to="/shoplist" className="nav-link">ShopList</Link>
        </li>
        <li className="nav-item">
          <button onClick={handleSignOut} className="nav-link btn btn-link">Sign out</button>
        </li>
      </ul>
    </nav>
    
  );
};

export default Navbar;
